import { Box } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { FC } from 'react';

interface MultiColorLinearProgressProps {
  value1: number; // secondary color
  value2: number; // primary color
  maxValue: number;
  height?: string;
}

export const MultiColorLinearProgress: FC<MultiColorLinearProgressProps> = ({
  value1,
  value2,
  maxValue,
  height = '8px',
}) => {
  const pct1 = maxValue ? Math.min((value1 / maxValue) * 100, 100) : 0;
  const pct2 = maxValue ? Math.min((value2 / maxValue) * 100, 100) : 0;

  const combinedPct = Math.min(pct1 + pct2, 100);

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <LinearProgress
        variant='determinate'
        value={combinedPct}
        color='primary'
        sx={{
          height,
          borderRadius: '16px',
          backgroundColor: 'lightgrey',
          '& .MuiLinearProgress-bar': {
            borderRadius: '16px',
          },
        }}
      />

      <Box sx={{ position: 'absolute', inset: 0 }}>
        <LinearProgress
          variant='determinate'
          value={pct1}
          color='secondary'
          sx={{
            height,
            borderRadius: '16px',
            backgroundColor: 'transparent',
            '& .MuiLinearProgress-bar': {
              borderRadius: '16px',
            },
          }}
        />
      </Box>
    </Box>
  );
};
